@import 'styles/mixins';
@import 'styles/variables';

.controlsContainer {
  align-items: center;
  display: flex;
  padding-bottom: 40px;
  min-height: 32px;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease-in-out;
  min-height: 38px;
  box-sizing: content-box;
}

.headerRow {
  display: flex;
  padding: 0 4px;
  width: $table-width;
}

.header {
  @include md-regular;

  color: var(--neutral-40);
  display: flex;
  align-items: center;

  .headerCheckbox svg {
    fill: transparent;
  }

  button {
    margin-right: 2px;
    display: flex;
    align-self: center;
    min-height: 0;
  }
}

html:not([data-design-system='blaze']) {
  .headerIcon {
    margin-right: 7px;
    display: flex;

    svg {
      color: $grey-30;
    }
  }
}

.columnText {
  @include md-regular;
  color: var(--neutral-90);
  display: flex;
  align-items: center;
}

.mainColumnText {
  @extend .columnText;
  color: $grey-90;

  a {
    color: $grey-90;
  }

  &:hover {
    color: $grey-90;
  }
}

.mainColumnSubText {
  @include line-clamp;
  @extend .columnText;
  @include sm-regular;

  margin-bottom: 0;
  margin-top: 2px;
}
